import React from "react";

// nodejs library to set properties for components
import PropTypes from "prop-types";

// @material-ui/core components
import { Grid } from "@mui/material";

const styles = {
  grid: {
    margin: "0 -15px !important",
    width: "unset"
  }
};


export default function GridContainer(props) {
  const { children, ...rest } = props;

  return (
    <Grid container {...rest} sx={styles.grid} >
      {children}
    </Grid>
  );
}

GridContainer.propTypes = {
  children: PropTypes.node
};
